// import {
// 	Carousel,
// 	CarouselContent,
// 	CarouselItem,
// 	CarouselNext,
// 	CarouselPrevious,
// } from '#app/components/ui/carousel'

const STORIES = [
	{
		title: 'Her Perspective',
		description: `The summer before college, I was scrolling through SDSU’s
	class of 2021 Facebook page. I stumbled upon Koan’s comment on
	a thread of snapchat usernames and immediately felt a sense of
	familiarity. I shot my shot via dms and we quickly bonded over
	our family backgrounds and shared birthdays.`,
	},
	{
		title: 'His Perspective',
		description: `True story, Summer of ‘17, Fiona slid in my DM’s. I didn’t think too much of it, but what really set it off was how similar we were— even down to our matching birthdays. As time went on, it was apparent we never got tired of each other. The rest is history!`,
	},
	{
		title: 'Our Perspective',
		description: `The first thing we always go to when asked about how we got together is the fact that we were born in the same hospital, on the same day, with the same doctor. Our parents actually bumped into each other in the hospital and we always joked that, “Fiona was just waiting for Koan to be born first so he could be the older one.” Besides sharing birthdays, we bonded over sharing very similar values and thinking, while still balancing each other’s differing personalities. 
	Other than that, it’s always funny telling our story to other people because it always starts with “she DM’d me,” but the truth is we weren’t really looking for anything serious at the time, One thing led to another and next thing you know, we were eating korean bbq for 3 hours and talking in the car until 4am. 
	Fast forward seven years, three college degrees, and two homes later, we’re ready for the next chapter in life!`,
	},
]

interface StoryProps {
	title: string
	description: string
}

function Story({ title, description }: StoryProps) {
	return (
		<div className="relative py-8">
			<div className="mx-auto">
				<h1 className="font-dreamAvenue text-h2 tracking-tight text-gray-900 sm:text-h1">
					{title}
				</h1>
				<p className="mt-6 text-body-lg leading-8 text-gray-600">
					{description}
				</p>
			</div>
		</div>
	)
}

// function StoriesAsCarousel() {
// 	return (
// 		<Carousel opts={{ loop: true }}>
// 			<CarouselContent>
// 				<CarouselItem>
// 					<Story
// 						title="Our Story: Her Perspective"
// 						description="The summer before college, I was scrolling through SDSU’s
// 				class of 2021 Facebook page. I stumbled upon Koan’s comment on
// 				a thread of snapchat usernames and immediately felt a sense of
// 				familiarity. I shot my shot via dms and we quickly bonded over
// 				our family backgrounds and shared birthdays."
// 					/>
// 				</CarouselItem>
// 				<CarouselItem>
// 					<Story
// 						title="Our Story: His Perspective"
// 						description="True story, Summer of ‘17, Fiona slid in my DM’s. I didn’t think too much of it, but what really set it off was how similar we were— even down to our matching birthdays. As time went on, it was apparent we never got tired of each other. The rest is history!"
// 					/>
// 				</CarouselItem>
// 				<CarouselItem>
// 					<Story
// 						title="Our Story: Our Perspective"
// 						description="The first thing we always go to when asked about how we got together is the fact that we were born in the same hospital, on the same day, with the same doctor. Our parents actually bumped into each other in the hospital and we always joked that, “Fiona was just waiting for Koan to be born first so he could be the older one.” Besides sharing birthdays, we bonded over sharing very similar values and thinking, while still balancing each other’s differing personalities.
// 				Other than that, it’s always funny telling our story to other people because it always starts with “she DM’d me,” but the truth is we weren’t really looking for anything serious at the time, One thing led to another and next thing you know, we were eating korean bbq for 3 hours and talking in the car until 4am.
// 				Fast forward seven years, three college degrees, and two homes later, we’re ready for the next chapter in life!
// 				"
// 					/>
// 				</CarouselItem>
// 			</CarouselContent>
// 			<CarouselPrevious />
// 			<CarouselNext />
// 		</Carousel>
// 	)
// }

// export default function OurStoryRoute() {
// 	return (
// 		<div className="relative items-center gap-3 md:container md:grid md:flex-1 md:grid-cols-2">
// 			<div>
// 				<div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:w-1/2">
// 					<img
// 						className="lg:aspect-auto object-cover md:aspect-[3/2] lg:h-full lg:w-full"
// 						src="/img/our-story.png"
// 						alt="Our Story"
// 					/>
// 				</div>

// 				<div className="inset-y-0 right-0 px-6 md:absolute md:px-12 lg:w-1/2">
// 					<div className="relative h-full overflow-y-auto">
// 						<div className="absolute flex flex-col">
// 							{STORIES.map(story => (
// 								<div key={story.title}>
// 									<Story title={story.title} description={story.description} />
// 								</div>
// 							))}
// 						</div>
// 					</div>
// 					{/* <StoriesAsCarousel /> */}
// 				</div>
// 			</div>
// 		</div>
// 	)
// }

export default function Route() {
	return (
		<div className="overflow-hidden bg-white">
			<div className="mx-auto max-w-7xl px-6 lg:px-8">
				<div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
					<div className="flex items-start justify-end">
						<img
							src="/img/our-story.png"
							alt="Product screenshot"
							className="w-full max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10"
						/>
					</div>
					<div className="lg:ml-auto lg:pl-4 lg:pt-4">
						<div className="lg:max-w-lg">
							<dl className="max-w-xl space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
								{STORIES.map(story => (
									<div key={story.title}>
										<Story
											title={story.title}
											description={story.description}
										/>
									</div>
								))}
							</dl>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
